export default function EsignExtraTip(props: any) {
  return null;
}
